import { call } from '@advanza/api'
import { LoadingDots } from '@advanza/ui'
import Card from 'components/Card'
import { BedrockChatInterface } from 'components/UpsellSalesAdviceChatBot/BedrockChatInterface'
import React, { useEffect, useState } from 'react'

interface UpsellChatPageProps {
    providerId: number
}

/**
 * Load an LLM chat that gives upsell advice for a provider
 *
 * Always uses an existing session if one exists.
 *
 * */
const AiUpsellAdvise: React.FC<UpsellChatPageProps> = ({ providerId }) => {
    // Previous session
    const [sessionId, setSessionId] = useState<string>()
    // Previous sessions messages
    const [messages, setMessages] = useState<object[]>()

    const [isLoading, setIsLoading] = useState(false)
    const loadPreviousSession = () => {
        setIsLoading(true)
        call(`office/sales-leads/upsell-advise-for-sales-get-previous-session/${providerId}`)
            .then(({ messages, sessionId }: { messages?: object[]; sessionId: string }) => {
                if (sessionId) {
                    setMessages(messages)
                    setSessionId(sessionId)
                }
            })
            .finally(() => setIsLoading(false))
    }
    useEffect(() => {
        loadPreviousSession()
    }, [providerId])

    return (
        <Card icon="robot" header={<span>Upsell sales advice</span>} useToggle>
            {isLoading && <LoadingDots />}
            {!isLoading && (
                <BedrockChatInterface
                    apiUrl={`office/sales-leads/upsell-advise-for-sales/${providerId}`}
                    history={messages}
                    sessionId={sessionId}
                    startChatOnMount={!sessionId}
                    closeChat={() => loadPreviousSession()}
                    key={providerId}
                />
            )}
        </Card>
    )
}

export default AiUpsellAdvise
